import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
// import ForgotPassword from "./ForgotPassword";
import { isAuthenticated } from '../helpers/authUtils';
import LuminateLogo from "assets/images/logo.png";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  hideMessage,
  showAuthLoader,
  studentSignIn,
  updateUsermode,
} from "actions/Auth";

class StudentSignin extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
    };
  }
  componentDidMount() {
    this.props.updateUsermode("Student");
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 400);
    }
    if (isAuthenticated(this.props.authUser)) {
      this.props.history.push("/student/dashboard");
    }
  }
  componentDidUpdate() {
    if (this.props.showMessage) {
      setTimeout(() => {
        this.props.hideMessage();
      }, 400);
    }
    if (isAuthenticated(this.props.authUser)) {
      this.props.history.push("/student/dashboard");
    }
  }

  render() {
    const { email, password } = this.state;
    const { showMessage, loader, alertMessage } = this.props;
    return (
      <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content">
          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <Link className="logo-lg" to="../" title="Luminate">
              <img
                src={LuminateLogo}
                alt="FedPolyLogo"
                title="FedPolyLogo"
              />
            </Link>
          </div>

          <div className="app-login-content">
            <div className="app-login-header mb-4">
              <h1>Student Login</h1>
              <h5
                className="d-flex align-items-center justify-content-center p-1"
                style={{ color: "#540000" }}
              >
                {" "}
                Returning student can login with their MatricNo while new
                student can login with their Application No
              </h5>
            </div>

            <div className="app-login-form">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.props.showAuthLoader();
                  this.props.studentSignIn({ email, password });
                }}
              >
                <fieldset>
                  <TextField
                    label={`Matric Number`}
                    fullWidth
                    onChange={(event) =>
                      this.setState({ email: event.target.value })
                    }
                    defaultValue={email}
                    margin="normal"
                    type="text"
                    className="mt-1 my-sm-3"
                    required
                  />
                  <TextField
                    type="password"
                    label={<IntlMessages id="appModule.password" />}
                    fullWidth
                    onChange={(event) =>
                      this.setState({ password: event.target.value })
                    }
                    defaultValue={password}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    required
                  />

                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <Button type="submit" variant="contained" style={{backgroundColor: "#540000", color: "#ffffff"}}>
                      <IntlMessages id="appModule.signIn" />
                    </Button>

                    <Link to="./ForgotPassword">
                      <IntlMessages id="appModule.forgotPassword"/>
                    </Link>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
        {loader && (
          <div className="loader-view">
            <CircularProgress />
          </div>
        )}
        {showMessage && NotificationManager.error(alertMessage)}
        <NotificationContainer />
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, studentUser } = auth;
  const authUser = studentUser;
  return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps, {
  studentSignIn,
  hideMessage,
  showAuthLoader,
  updateUsermode
})(StudentSignin);
